<template>
	<el-dialog :title="$t('detailGroup.groupInformation')" :visible.sync="dialogVisible" width="960px" height="760px" :append-to-body="true">
		<section v-loading="loading">
			<div class="group-name-content">
				<div class="group-name-text">
					<span>{{ $t("detailGroup.groupChatName") }}{{ groupName }}</span>
				</div>
				<div class="group-name-button">
					<el-button class="group-button" size="mini" @click="changeGroupName()">{{ $t("detailGroup.modifyGroupName") }}</el-button>
					<el-button v-if="type != 2" size="mini" type="primary" @click="addMember">{{ $t("detailGroup.addMember") }}</el-button>
				</div>
			</div>
			<el-table :data="members" style="width: 100%" :empty-text="$t('detailGroup.noData')" v-loading="loading" max-height="500">
				<el-table-column :label="$t('detailGroup.avatar')" width="80">
					<template slot-scope="scope">
						<el-avatar shape="square" @error="errorHandler" :src="scope.row.avatar_url"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column :label="$t('detailGroup.nickName')" prop="nick_name">
					<template slot-scope="scope">
						<span class="nick-name-text">{{ scope.row.nick_name }}</span>
						<span v-if="isGroupOwner(scope.row)" class="group-owner-badge">{{ $t("detailGroup.groupOwner") }}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('detailGroup.groupNotes')" prop="group_member_note"> </el-table-column>
				<el-table-column :label="$t('detailGroup.operate')" width="280">
					<template slot-scope="scope">
						<el-button size="mini" @click="editGroupMemberNote(scope.row)">{{ $t("detailGroup.editorNotes") }}</el-button>
						<el-button v-if="type != 2" size="mini" type="danger" @click="removeMember(scope.row.id)">{{
							$t("detailGroup.removeMember")
						}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<SelectMember
				v-if="visiableAddMember"
				:membersId="membersId"
				@select-member-close-click="selectMemberClose()"
				:visiableAddMember="visiableAddMember"
				v-on:onSubmit="inviteMembersSubmit"
			>
			</SelectMember>
		</section>
	</el-dialog>
</template>

<script>
import { getGroup, updateGroup, inviteMembers, kickMembers, putEditGroupMemberNote } from "@/services/api-v2/api-v2";

import SelectMember from "./select-member";

import _ from "lodash";

export default {
	name: "DetailGroup",

	components: {
		SelectMember,
	},

	props: {
		conversation: {
			type: Object,
			required: false,
			default: null,
		},
	},

	data() {
		return {
			loading: false,

			dialogVisible: false, // 详情窗口

			visiableAddMember: false, // 选择成员窗口

			groupName: "", // 组名

			members: [], // 群成员

			type: null, // 群成员

			membersId: [], // 成员ID

			contacts: [], // 联系人

			sales: [], // sales

			groupId: "", // 群id
		};
	},

	methods: {
		// 打开
		async open() {
			this.initGetMembers(this.conversation.object_id);
		},

		//获取群详情中的成员
		async initGetMembers(groupId) {
			try {
				this.loading = true;
				const { data } = await getGroup(groupId);
				this.dialogVisible = true;
				this.groupId = data.id;
				this.groupName = data.name;
				this.type = data.type;
				this.members = data.members;
				this.loading = false;
			} catch (e) {
				this.dialogVisible = false;
				this.loading = false;
				this.$message({ message: this.$t("detailGroup.userDoesNotBelong"), type: "warning" });
			}
		},

		// 邀请成员
		addMember() {
			this.visiableAddMember = true;
			this.initMemberIds();
		},

		// 初始化群组成员id
		initMemberIds() {
			this.membersId = _.map(this.members, "id");
		},

		// 关闭选择成员窗口
		selectMemberClose() {
			this.visiableAddMember = false;
		},

		// 编辑成员备注
		editGroupMemberNote(row) {
			this.$prompt(this.$t("detailGroup.enterTheCommentName"), this.$t("detailGroup.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				inputValue: row.group_member_note,
				closeOnClickModal: false,
			})
				.then((val) => {
					this.changeGroupMemberNote(row.id, val.value);
				})
				.catch(() => {});
		},

		// 更新成员备注
		changeGroupMemberNote(memberId, note) {
			putEditGroupMemberNote(this.groupId, memberId, note).then(
				(response) => {
					_.find(this.members, { id: memberId }).group_member_note = note;
					this.$emit("handle-update-group-member-note", memberId, note);
					this.$message({ message: "success", type: "success" });
				},
				(error) => {
					this.$message({ message: error, type: "error" });
				}
			);
		},

		// 添加群聊成员
		inviteMembersSubmit(data) {
			// 遍历新添加的成员id
			const membersId = data.contacts_id.filter((element) => {
				return !this.membersId.includes(element);
			}, this);

			if (membersId.length === 0) {
				this.$message({ message: this.$t("detailGroup.selectMembers"), type: "success" });
				return false;
			}

			inviteMembers(this.groupId, membersId).then(
				(response) => {
					this.$message({ message: "success", type: "success" });
					this.initGetMembers(this.groupId);
					this.visiableAddMember = false;
				},
				(error) => {
					this.$message({ message: error.message, type: "error" });
				}
			);
		},

		// 修改群聊名称
		changeGroupName() {
			this.$prompt(this.$t("detailGroup.pleaseEnterTheGroupChatName"), this.$t("detailGroup.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				inputValue: this.groupName,
				closeOnClickModal: false,
			})
				.then((val) => {
					this.upateGroupName(val.value);
				})
				.catch(() => {});
		},

		// 更新群聊名称
		upateGroupName(groupName) {
			if (groupName.trim() === this.groupName.trim()) {
				this.$message({ message: this.$t("detailGroup.groupNameHasNotChanged"), type: "warning" });
				return false;
			}

			if (groupName.trim() === "") {
				this.$message({ message: this.$t("detailGroup.groupNameCannotBeEmpty"), type: "warning" });
				return false;
			}

			updateGroup(this.groupId, groupName).then(
				(response) => {
					this.groupName = groupName;
					this.conversation["object_name"] = groupName;
					this.$message({ message: "success", type: "success" });
				},
				(error) => {
					this.$message({ message: error.message, type: "error" });
				}
			);
		},

		// 移除成员
		removeMember(memberId) {
			const _this = this;
			this.$confirm(this.$t("detailGroup.confirmToRemoveMember"), this.$t("detailGroup.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				kickMembers(this.groupId, [memberId])
					.then((reponse) => {
						this.$message({
							type: "success",
							message: reponse.message,
						});
						reponse && _this.removeGroupMembersFormDataScoure(memberId);
					})
					.catch((error) => {
						this.$message({ message: error, type: "error" });
					});
			});
		},

		// 移除成员包括过滤页面上的数据
		removeGroupMembersFormDataScoure(memberId) {
			this.members = this.members.filter((element) => {
				return element.id !== memberId;
			});
		},

		// 头像破图
		errorHandler() {
			return true;
		},

		// 是否群主（接口返回 is_manager 为 true 时标识群主）
		isGroupOwner(row) {
			return row.is_manager === true || row.is_manager === 1 || row.is_manager === "true" || row.is_manager === "1";
		},
	},

	computed: {},
};
</script>
<style lang="less">
.el-dialog__body {
	padding: 14px 30px 14px 30px !important;
}

.el-col-5 {
	width: 19.9%;
}
</style>

<style lang="less" scoped>
.text-aliges {
	text-align: center !important;
	border-bottom: 2px solid #cecece;
}

.user-name {
	margin: 6px 0 26px 0;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	text-align: center !important;
}

.add-member {
	font-size: 26px;
	height: 40px;
	width: 40px;
	text-align: center;
	line-height: 40px;
	border: 2px solid #f7f7f9;
	border-radius: 5px;
	cursor: pointer;
	margin-top: 4px;
	margin-bottom: 20px;
}

.group-name-content {
	margin-top: 20px !important;
	line-height: 32px;
	margin-bottom: 10px !important;
	height: 40px;
}

.group-name-text {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	float: left;
}
.group-name-button {
	float: right;
}

.group-button {
	margin-left: 6px;
}

.nick-name-text {
	vertical-align: middle;
}

.group-owner-badge {
	display: inline-block;
	margin-left: 6px;
	padding: 0 6px;
	height: 18px;
	line-height: 16px;
	vertical-align: middle;
	font-size: 12px;
	font-weight: 400;
	color: #8c5a00;
	background-color: #fff7e6;
	border: 1px solid #f3c896;
	border-radius: 9px;
	white-space: nowrap;
}

.position {
	position: relative;
}

.delete-button {
	position: absolute;
	background-color: #fff;
	border-radius: 50%;
	top: -8px;
	font-size: 18px;
	right: 25px;
	color: #f56c6c;
}

.show-more-members {
	text-align: center;
	cursor: pointer;
	user-select: none;
}
</style>
